/**
 * @module app.devance.movements.servMvtsCtrl
 */
define(['angular', 'moment'], function(angular, moment) {
    function ServMvtsCtrl($scope, $window, $location, $sce, authService, mvtsService, x3Service) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
        // $scope.selectActiveMenu(8);
         var vm = {};

        // Initialisation du paramétrage par défaut
        vm.mvts = [];
        vm.pageLimit = 500;
        vm.rowsCount = 0;
        vm.currentPage = 1;
        vm.pagesList = [1];
        vm.offset = (vm.currentPage - 1) * vm.pageLimit;
        
        vm.selectedMvtName = null;
        vm.mvtNameList = [{ id:'TOUS', label: 'TOUS'}];

        vm.selectedMvtStatus = null;
        vm.statusList = [{ id: 'TOUS', label: 'TOUS' }];
        vm.mvtStatusList = [];

        vm.diodList = null;

        vm.dateMin = new Date(moment().subtract(1, 'months').startOf('day').valueOf());

        vm.orderBy = {
            colName: null,
            sort: null
        };

        // Fonctions
        vm.orderByFunct = (colName) => {
            if(vm.orderBy.colName !== colName || (vm.orderBy.colName === colName && vm.orderBy.sort == null)) {
                vm.orderBy.colName = colName;
                vm.orderBy.sort = 'asc';
                vm.mvtsSearch();
                return;
            }
            if(vm.orderBy.sort === 'asc') {
                vm.orderBy.sort = 'desc';
            }
            else {
                vm.orderBy.sort = null;
            }
            vm.mvtsSearch();
        };

        vm.changePage = (pageVal) => {
            vm.currentPage = pageVal;
            vm.reinitTable();
            vm.loadTable();
        };

        vm.reinitTable = () => {
            vm.mvts = [];
            // vm.mvtNameList = ['TOUS'];
            // vm.statusList = [{ id: 'TOUS', label: 'TOUS' }];
        };

        vm.mvtsSearch = () => {
            // console.log('Paramètres de recherche', vm.getParams());
            vm.reinitTable();
            vm.loadTable();
        };

        vm.formatAddress = (coord) => {
            return coord ? coord.adresseA + (coord.adresseB ? ' ' + coord.adresseB + ' ' : '') : null;
        };

        vm.smartStatus = (status) => {
            return vm.status[status];
        };

        vm.getParams = () => {
            if(!vm.selectedMvtName) {
                vm.selectedMvtName = 'onBoardedService';
            }
            if(!vm.selectedMvtStatus) {
                vm.selectedMvtStatus = '0';
            }
            let typesParam = vm.selectedMvtName === 'TOUS' ?
                vm.mvtNameList.map(x => x.id).filter(x => x !== 'TOUS').join(',') : vm.selectedMvtName;
            let statutsParam = vm.selectedMvtStatus.toString()  === 'TOUS' ?
                vm.statusList.map(x => x.id).filter(x => x !== 'TOUS').join(',') : vm.selectedMvtStatus.toString();
            let dateMinParam = moment.unix(vm.dateMin.getTime() / 1000).toISOString(true);
            let diodListParam = vm.diodList || '';
            return [typesParam, statutsParam, diodListParam, dateMinParam, vm.orderBy.colName, vm.orderBy.sort];
        };

        vm.loadTable = () => {
            return mvtsService.listServMvtsTypes()
                .then((types) => {
                    if(!vm.selectedMvtName) {
                        vm.mvtNameList = vm.mvtNameList.concat(types);
                    }
                    return mvtsService.listServStatus();
                })
                .then((status) => {
                    if(!vm.selectedMvtStatus) {
                        vm.statusList = vm.statusList.concat(status);
                        vm.mvtStatusList = vm.mvtStatusList.concat(status);
                    }
                    return mvtsService.countMvts(vm.getParams());
                })
                .then((count) => {
                    vm.rowsCount = count.count;
                    vm.offset = (vm.currentPage - 1) * vm.pageLimit;
                    vm.nbPage = Math.ceil(vm.rowsCount / vm.pageLimit);
                    vm.pagesList = [];
                    for(let index = 1; index <= vm.nbPage; index++) {
                        vm.pagesList.push(index);
                    }

                    let params = vm.getParams();
                    params.push(vm.offset);
                    return mvtsService.listMvts(params);
                })
                .then((rows) => {
                    vm.mvts = rows;
                })
                .catch((err) => {
                    console.error(err);
                    vm.displayError(err);
                });
        };

        // Modal comparator
        vm.comparator = (diod, mvt) => {
            vm.comparatorModal = {
                devancePosInfos: {},
                posX3List: [],
                isSearch: false
            };
            vm.comparatorModal.diod = diod;
            vm.comparatorModal.mvt = mvt;
            return mvtsService.getDevancePosInfos(diod)
                .then((posInfos) => {
                    console.log('posInfos', posInfos);
                    vm.comparatorModal.devancePosInfos = posInfos;
                    let srdEnrollment = posInfos.services.find(x => (x.service === 'SRD' && (x.enrolementService
                        && x.enrolementService.liasse)));
                    if(srdEnrollment) {
                        vm.comparatorModal.devancePosInfos.enrolementService = srdEnrollment.enrolementService;
                    }
                    $('#comparatorModal').modal('show');
                })
                .catch((err) => {
                    console.error(err);
                    vm.displayError(err);
                });
        };

        // Modal error
        vm.errorModal = {
            error: null
        };

        vm.displayError = (err) => {
            vm.errorModal.error = err;
            $('#errorModal').modal('show');
        };

        vm.x3PosSearch = () => {
            return mvtsService.getX3PosByDiod(vm.comparatorModal.devancePosInfos.diod)
                .then((posX3List) => {
                    console.log('posX3List', posX3List);
                    vm.comparatorModal.posX3List = posX3List;
                    vm.comparatorModal.isSearch = true;
                })
                .catch((err) => {
                    console.error(err);
                    vm.displayError(err);
                });
        };

        vm.updateStatus = (diod, type, date_demande, newStatus, reThrow) => {
            return mvtsService.updateMvtStatus(diod, type, date_demande, newStatus)
                .then((res) => {
                    console.log('updateStatus', diod, type, date_demande, res);
                    vm.showToast();
                })
                .catch((err) => {
                    if(reThrow)
                        throw err;
                    console.error(err);
                    vm.displayError(err);
                });
        };

        vm.treatMvt = (mvt, status) => {
            console.log('traiter : ' + mvt.diod + ' ' + mvt.type + ' ' + mvt.date_demande);
            for(let i = 0; i < vm.mvts.length; i++) {
                if(vm.mvts[i] && (vm.mvts[i].diod+vm.mvts[i].type+vm.mvts[i].date_demande === mvt.diod+mvt.type+mvt.date_demande)) {
                    vm.updateStatus(vm.mvts[i].diod, vm.mvts[i].type, vm.mvts[i].date_demande, status, true)
                        .then(() => {
                            vm.mvts[i].statut = status.toString();
                        })
                        .catch((err) => {
                            console.error(err);
                            vm.displayError(err);
                        });
                }
            }
        };

        vm.updatePosX3 = (pos, devancePosInfos) => {
            let accountSrd = null, params = null;
            vm.updatePosX3Load = true;
            try {
                accountSrd = devancePosInfos.enrolementService.liasse.banks.find(x => x.rum.slice(-3) === 'SRD');
                if(!accountSrd) {
                    console.error('Mandate srd is missing');
                    vm.displayError({message: 'Mandate srd is missing'});
                    return;
                }
                params = [{
                    refX3: pos.identifiant_magasin_x3,
                    socialReason: devancePosInfos.enrolementService.liasse.establishment.companyName,
                    brand: devancePosInfos.enrolementService.liasse.establishment.brand,
                    siret: devancePosInfos.enrolementService.liasse.establishment.siret,
                    vatIntra: devancePosInfos.tvaIntraCommunautaire,
                    address: devancePosInfos.enrolementService.liasse.establishment.addressA,
                    zipCode: devancePosInfos.enrolementService.liasse.establishment.zipCode,
                    city: devancePosInfos.enrolementService.liasse.establishment.city,
                    mail: devancePosInfos.enrolementService.liasse.establishment.mail,
                    phone: devancePosInfos.enrolementService.liasse.establishment.phone.replace('+33', '').replaceAll(' ', ''),
                    iban: accountSrd.iban,
                    bic: accountSrd.bic,
                    contact: {
                        codeContact: pos.customers[0].identifiant_client.toString().padStart(15, '0'),
                        firstName: devancePosInfos.enrolementService.liasse.admins[0].firstname,
                        name: devancePosInfos.enrolementService.liasse.admins[0].name
                    }
                }];
            } catch (err) {
                console.error(err);
                vm.displayError(err);
            }
            
            // Diod test 0548966
            return x3Service.updatePos(params)
                .then((upPos) => {
                    vm.updatePosX3Load = false;
                    console.log('updatePos', upPos);
                    if(upPos.status === 'OK') {
                        vm.showToastX3();
                    }
                    else {
                        console.error('Update x3 failed', upPos);
                        throw new Error('Update x3 failed');
                    }
                })
                .catch((err) => {
                    vm.updatePosX3Load = false;
                    console.error(err);
                    vm.displayError(err);
                });
        };

        vm.importMandatX3 = (pos, devancePosInfos) => {
            let accountSrd = null, accountSmp = null, params = null;
            vm.importMandatX3Load = true;
            try {
                accountSrd = devancePosInfos.enrolementService.liasse.banks.find(x => x.rum.slice(-3) === 'SRD');
                accountSmp = devancePosInfos.enrolementService.liasse.banks.find(x => x.rum.slice(-3) === 'DMP');
                if(!accountSrd) {
                    console.error('Mandate srd is missing');
                    vm.displayError({message: 'Mandate srd is missing'});
                    return;
                }
                if(!accountSmp) {
                    console.error('Mandate smp is missing');
                    vm.displayError({message: 'Mandate smp is missing'});
                    return;
                }
                params = [{
                    refX3: pos.identifiant_magasin_x3,
                    zipCode: devancePosInfos.enrolementService.liasse.establishment.zipCode,
                    city: devancePosInfos.enrolementService.liasse.establishment.city,
                    rum: accountSrd.rum,
                    date: devancePosInfos.enrolementService.liasse.signature.date.slice(0,10),
                    society: 'SRDTE'
                }, {
                    refX3: pos.identifiant_magasin_x3,
                    zipCode: devancePosInfos.enrolementService.liasse.establishment.zipCode,
                    city: devancePosInfos.enrolementService.liasse.establishment.city,
                    rum: accountSmp.rum,
                    date: devancePosInfos.enrolementService.liasse.signature.date.slice(0,10),
                    society: 'SRDMP'
                }];
            } catch (err) {
                console.error(err);
                vm.displayError(err);
            }
            
            // Diod test 0548966
            return x3Service.createMandate(params)
                .then((impMand) => {
                    vm.importMandatX3Load = false;
                    console.log('createMandate', impMand);
                    if(impMand.status === 'OK') {
                        vm.showToastX3();
                    }
                    else {
                        console.error('Update x3 failed', impMand);
                        throw new Error('Update x3 failed');
                    }
                })
                .catch((err) => {
                    vm.importMandatX3Load = false;
                    console.error(err);
                    vm.displayError(err);
                });
        };

        vm.openDoc = (link, diod) => {
            return mvtsService.downloadFile(link)
                .then(data => {
                    let fileName = diod + '_liasse.pdf';
                    let a = document.createElement('a');
                    document.body.appendChild(a);
                    let file = new Blob([data.data], {type: 'application/pdf'});
                    let fileURL = window.URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = fileName;
                    a.click();
                })
                .catch(err => {
                    console.error(err);
                    vm.displayError(err);
                });
        };

        vm.showToast = () => {
            $('#liveToast').toast('show');
        };

        vm.showToastX3 = () => {
            $('#liveToastX3').toast('show');
        };

        vm.goTo = (path) => {
            $location.path(path);
        };

        vm.getEnterKey = (event) => {
            if(event && event.keyCode === 13) {
                vm.mvtsSearch();
            }
        };

        // Chargement des données
        vm.loadTable();

        return vm;
    }

    ServMvtsCtrl.$inject = [
        '$scope', '$window', '$location', '$sce', 'authService', 'mvtsService', 'x3Service'
    ];

    angular
        .module('app.devance.movements.servMvtsCtrl', ['ui.bootstrap', 'ui-notification'])
        .controller('ServMvtsCtrl', ServMvtsCtrl);
});
